function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip7)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.68427 19.7366C6.15796 19.2629 6.15796 18.4734 5.68427 18.0787L4.18427 16.5787H17.2895C17.9211 16.5787 18.5527 16.0261 18.4737 15.3945C18.4737 15.0787 18.3159 14.7629 18.079 14.5261C17.8422 14.2892 17.5264 14.2103 17.2106 14.1313H4.10533L5.60533 12.6313C6.07901 12.1576 6.07901 11.3682 5.60533 10.9734C5.13164 10.4997 4.34217 10.4997 3.94743 10.9734L0.473747 14.5261L0.3948 14.605L0.315855 14.684C0.315855 14.684 0.315853 14.684 0.236904 14.7629L0.157959 14.8418L0.07901 15.3155V15.3945C0.07901 15.3945 0.07901 15.3945 0.07901 15.4734H0.315855H0.07901V15.7892H0.236904L0.07901 15.9471L0.157959 16.0261L0.236904 16.105L0.315855 16.184C0.394802 16.2629 0.3948 16.2629 0.3948 16.2629L3.86849 19.7366C4.42112 20.1313 5.21059 20.1313 5.68427 19.7366Z",
  fill: "url(#paint18_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.18416 8.44752C0.473636 8.44752 -4.76837e-05 7.89489 -4.76837e-05 7.26331C-4.76837e-05 6.55279 0.552584 6.0791 1.18416 6.0791C1.81574 6.0791 2.36837 6.63173 2.36837 7.26331C2.44732 7.89489 1.89469 8.44752 1.18416 8.44752Z",
  fill: "url(#paint19_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.36842 22.6579V26.0526C2.36842 26.9211 3.07895 27.5526 3.86842 27.5526H26.1316C26.9211 27.6316 27.6316 26.9211 27.6316 26.1316V3.86842C27.6316 3.07895 26.9211 2.36842 26.1316 2.36842H3.94737C3.07895 2.36842 2.36842 3.07895 2.36842 3.86842V7.26316C2.36842 7.6579 2.05263 7.97368 1.65789 7.97368H0.789473C0.394735 7.97368 0.0789452 7.6579 0.0789452 7.26316V3.86842C-1.90735e-06 1.73684 1.73684 0 3.86842 0H26.1316C28.2632 0 30 1.73684 30 3.86842V26.0526C30 28.2632 28.2632 30 26.1316 30H3.94737C1.81579 30 0.0789452 28.2632 0.0789452 26.1316V22.7368C0.0789452 22.3421 0.394735 22.0263 0.789473 22.0263H1.65789C2.05263 21.9474 2.36842 22.2632 2.36842 22.6579Z",
  fill: "url(#paint20_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.18416 23.7628C0.473636 23.7628 -4.76837e-05 23.2102 -4.76837e-05 22.5786C-4.76837e-05 21.947 0.552584 21.3154 1.18416 21.3154C1.81574 21.3154 2.36837 21.8681 2.36837 22.4996C2.44732 23.1312 1.89469 23.7628 1.18416 23.7628Z",
  fill: "url(#paint21_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear",
  x1: 9.27973,
  y1: 10.6182,
  x2: 9.27973,
  y2: 20.0326,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint19_linear",
  x1: 1.18792,
  y1: 6.0791,
  x2: 1.18792,
  y2: 8.44752,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear",
  x1: 15.0382,
  y1: 0,
  x2: 15.0382,
  y2: 30,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear",
  x1: 1.18792,
  y1: 21.3154,
  x2: 1.18792,
  y2: 23.7628,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  fill: "white",
  transform: "matrix(-1 0 0 1 30 0)"
})));

function SvgSignout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.a4959efc.svg";
export { ForwardRef as ReactComponent };